/**
 * main.tsx — mount entry. Imports global styles before rendering.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles/index.css";
import App from "@/App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("animachord: #root element missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
